import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    breadcrumbs: [],
    pageTitle: '',
    notifications: [],
    online: true,
  },
  reducers: {
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
      document.title = action.payload ? `${action.payload} | Dine Savvy` : 'Dine Savvy';
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    setOnlineStatus: (state, action) => {
      state.online = action.payload;
    },
  },
});

export const {
  setBreadcrumbs,
  setPageTitle,
  addNotification,
  clearNotifications,
  setOnlineStatus,
} = commonSlice.actions;
export default commonSlice.reducer;
